import { API_BASE } from "./api";

const apiRoot = API_BASE+"/";//"https://localhost:7087/api/";


export default {
  meEndpoint: "/auth/me",
  user: `${apiRoot}User/login`,
  userRefresh: `${apiRoot}User/refresh`,
  loginEndpoint: `${apiRoot}User/login`,
  registerEndpoint: `${apiRoot}User/create`,
  activateToken: `${apiRoot}User/validate`,
  passwordChangeRequest: `${apiRoot}User/RequestEmail?reason=password`,
  passwordChangePerform: `${apiRoot}User/password`,
  setScheduleEndpoint: `${apiRoot}BookingSystem/set-schedule`,
  getSlotsByDate: `${apiRoot}BookingSystem/slots-by-date`,
  bookSlot: `${apiRoot}BookingSystem/book-slot`,
  customerNames: "/jwt/customers",
  storageTokenKeyName: "accessToken",
  onTokenExpiration: "refreshToken", // logout | refreshToken
};
